import { memo, useCallback } from 'react';
import { ButtonBase, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useSetFieldValue } from '@client/hooks/formik.hooks';

const useStyles = makeStyles()((theme) => ({
  root: {
    color: theme.palette.text.disabled,
    textDecoration: 'underline',

    '&:hover': {
      textDecoration: 'none',
    },
  },
}));

export const ClearDateRange = memo(() => {
  const { classes } = useStyles();
  const setFieldValue = useSetFieldValue();

  const handleClearDateSelection = useCallback(() => {
    void setFieldValue('dateRange', []);
  }, [setFieldValue]);

  return (
    <ButtonBase
      component={Typography}
      className={classes.root}
      onClick={handleClearDateSelection}
    >
      Clear selection
    </ButtonBase>
  );
});
